module.exports = __webpack_public_path__ + "static/media/menu_white.25669d04.svg";